// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}


	/*** Slider-double cicle SVG animation */
	document.addEventListener('DOMContentLoaded', () => {
		const circles = document.querySelectorAll('.animated-circle');

		if (circles.length) {
		  const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
			  if (entry.isIntersecting) {
				entry.target.classList.add('animate');
				observer.unobserve(entry.target);
			  }
			});
		  }, { threshold: 0.5 });

		  circles.forEach(circle => {
			observer.observe(circle);
		  });
		}
	  });
	/***  END Slider-double circle SVG animation */


	/** Location map Functionality */

	if(document.querySelector(".location .map-container__pins")) {
		const mapPins = document.querySelectorAll( ".location .map-container__pins .pin .number");

		mapPins.forEach( (item)=> {
			item.addEventListener('click', (e) => {
				mapPins.forEach( (item) => {
					item.parentElement.classList.remove("opened");
				})
				item.parentElement.classList.add("opened");
			})
		});
	}

	if(document.querySelector(".location .location__submap")) {
		const mapPins = document.querySelectorAll( ".location .location__submap .pin .number");
		const closerSubmap = document.querySelector(".location .location__submap .js-back");
		const subMap = document.querySelector(".location .location__submap");
		const primaryLocation = document.querySelector('.js-primary-location');

		mapPins.forEach( (item)=> {
			item.addEventListener('click', (e) => {
				mapPins.forEach( (item) => {
					item.parentElement.classList.remove("opened");
				})
				item.parentElement.classList.add("opened");
			})
		});

		if(closerSubmap) {
			closerSubmap.addEventListener('click', () => { 
				closerSubmap.parentNode.classList.add('hidden');
				primaryLocation.classList.remove('hidden');
			})
		}

		document.querySelector('.js-primary-location').addEventListener('click', () => {
			subMap.classList.remove('hidden');
			primaryLocation.classList.add('hidden');
		})

		
	}


	/** END Location map Functionality */



	/* Multitab Hero functionality */

	if (document.querySelectorAll('.multitab-hero .tabs .tab').length > 0) {
    const tabs = document.querySelectorAll('.multitab-hero .tabs .tab');
    const contentBoxes = document.querySelectorAll('.content_box');
    function removeClass(elements, className) {
        elements.forEach(element => element.classList.remove(className));
    }

    
    tabs.forEach(currentTab => {
        currentTab.addEventListener('click', () => {
            removeClass(tabs, 'active');
            currentTab.classList.toggle('active');
            let entry = currentTab.dataset.entry;

            contentBoxes.forEach(box => {
                box.classList.add('not-visible');
                if (box.dataset.entry === entry) {
                    box.classList.remove('not-visible');
                }
            });
        });
    });

    tabs[0].click();

    let currentIndex = 0; 
    const intervalTime = 8000;

    function autoRotateTabs() {
        removeClass(tabs, 'active');
        currentIndex = (currentIndex + 1) % tabs.length;
        tabs[currentIndex].click();
    }

    const rotationInterval = setInterval(autoRotateTabs, intervalTime);
    // tabs.forEach(tab => {
    //     tab.addEventListener('click', () => {
    //         clearInterval(rotationInterval); 
    //     });
    // });
	}
	/* END Multitab Hero functionality */


	/**Team Quad Functionality*/

	if( document.querySelectorAll('.team-quad .grid__item') ) {
		// const quadsCollection = document.querySelectorAll('.team-quad');

		// quadsCollection.forEach( quad => {
		// 	let quadItems = quad.querySelectorAll('.team-quad__columns .grid__item');
		// 	let quadSlider = quad.querySelector('.team-quad__slider');
		// 	let columns_container = quad.querySelector('.team-quad__columns')
		// 	let nameSlider = quad.querySelector('.quad-slider__names');
		// 	const offset = 150;

		// 	quadItems.forEach( item => {
		// 		item.addEventListener('click', (e) => {
		// 			const itemId = item.dataset.id;
		// 			quadSlider.parentNode.classList.add('active');

		// 			let slidesCollection = quadSlider.querySelectorAll('.item.swiper-slide')
		// 			slidesCollection = [...slidesCollection];


		// 			let slideIndex = slidesCollection.findIndex(( slide ) => slide.dataset.id === itemId );
		// 			quadSlider.swiper.slideTo(slideIndex);


		// 			quadSlider.swiper.on('slideChange', function () {
		// 				nameSlider.swiper.slideTo(this.realIndex);
		// 			});
					
		// 			columns_container.classList.add('hide');
		// 			const elementPosition = quadSlider.getBoundingClientRect().top + window.scrollY;
		// 			window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
		// 		});
		// 	});


			// let nameSlider_slides = nameSlider.querySelectorAll('.swiper-slide');
			// nameSlider_slides.forEach( slide => {
			// 	slide.addEventListener('click', () => {
			// 		const index_id = slide.dataset.id;

			// 		let slidesCollection = quadSlider.querySelectorAll('.item.swiper-slide')
			// 		slidesCollection = [...slidesCollection];

			// 		let slideIndex = slidesCollection.findIndex(( slide ) => slide.dataset.id === index_id );
			// 		quadSlider.swiper.slideTo(slideIndex);
			// 	})
			// })

		// 	quad.querySelector('.closer').addEventListener('click', () => {
		// 		console.log(quad.querySelector('.closer'));

		// 		quadSlider.parentNode.classList.remove('active');
		// 		columns_container.classList.remove('hide');

		// 		const elementPosition = columns_container.getBoundingClientRect().top + window.scrollY;
		// 		window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
		// 	})
		// })
	}
	/**End Team Quad Functionality*/



	/** MOBILE NAV */

	if(document.querySelector('.mobile-navbar .js-menu')) {
		let mobileNavButton = document.querySelector('.mobile-navbar .js-menu');
		let navigation = document.querySelector('.navigation.overlay');

		mobileNavButton.addEventListener('click', () => {
			navigation.classList.toggle('active');
		})
	}

	if( document.querySelector('.navigation.overlay .close-menu')){
		let mobileCloser = document.querySelector('.navigation.overlay .close-menu')
		let navigation = document.querySelector('.navigation.overlay');
		mobileCloser.addEventListener('click', () => {
			navigation.classList.remove('active');
		})
	}
	/** END MOBILE NAV */


	if( document.querySelectorAll('.btn') ) {
		document.querySelectorAll('.btn').forEach(button => {
			const text = button.textContent.trim();
	
			const span = document.createElement('span');
			span.textContent = text;
	
			button.textContent = '';
			button.appendChild(span);
		});
	}


	new LBX(".js-rooms-lbx" , {
		customClass: "content-lightbox"
	});

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if(document.querySelector("#gallery-flex") !== null){
			document.getElementById('header').classList.add('up')
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}